import config from 'app/config';
export const VIDEO_VENDORS = {
    STREAMAX: 'streamax',
    DAHUA: 'dahua',
    HIKVISION: 'hikvision',
};
/**
 * Соответствие типа телематики видеовендору, если у ТС нет явного video_vendor.
 * Galileosky смотрит Streamax CMS по госномеру; субподрядный Wialon — без видео.
 */
const VENDOR_BY_DEVICE_NAME = {
    galileosky: VIDEO_VENDORS.STREAMAX,
    streamax: VIDEO_VENDORS.STREAMAX,
};
function isVideoVendor(value) {
    return Object.values(VIDEO_VENDORS).includes(value);
}
function resolveVendorByDeviceType(deviceType) {
    var _a;
    if (deviceType == null || deviceType === '') {
        return null;
    }
    const name = config.transportDeviceTypes[deviceType] || deviceType;
    return (_a = VENDOR_BY_DEVICE_NAME[String(name)]) !== null && _a !== void 0 ? _a : null;
}
/**
 * Вендор видео для ТС. Явное video_vendor важнее типа терминала;
 * пустое значение — «Не задан», без отката на Galileosky → Streamax.
 */
export function resolveVideoVendor(transport) {
    if (!transport) {
        return null;
    }
    if (Object.prototype.hasOwnProperty.call(transport, 'video_vendor')) {
        const vendor = transport.video_vendor;
        if (!vendor) {
            return null;
        }
        return isVideoVendor(vendor) ? vendor : null;
    }
    return resolveVendorByDeviceType(transport.device_type);
}
export function hasVideoSource(transport) {
    return resolveVideoVendor(transport) != null;
}
export function getBroadcastDeviceId(broadcast) {
    var _a;
    if (!broadcast) {
        return null;
    }
    const id = (_a = broadcast.deviceId) !== null && _a !== void 0 ? _a : broadcast.terid;
    if (id == null || String(id).length === 0) {
        return null;
    }
    return id;
}
export function hasBroadcastSession(broadcast) {
    return getBroadcastDeviceId(broadcast) != null;
}
